import { render, staticRenderFns } from "./ReplacementMonthlyStatistics.vue?vue&type=template&id=70bb03b4&"
import script from "./ReplacementMonthlyStatistics.vue?vue&type=script&lang=js&"
export * from "./ReplacementMonthlyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports